var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "workpackage-pricing-groups" }, [
    !_vm.collapsedView
      ? _c(
          "div",
          { staticClass: "d-flex justify-space-between align-center mb-4" },
          [_c("div", { staticClass: "pg-title" }, [_vm._v("Pricing groups")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: { "horizontal-scroll-container": _vm.collapsedView } },
      _vm._l(_vm.pricingGroups, function (unit, i) {
        return _c(
          "div",
          {
            key: `pricingGroup${i}`,
            class: { "pricing-group-item": _vm.collapsedView },
          },
          [
            _c("workpackage-pg-item", {
              attrs: {
                unit: unit,
                categories: _vm.getCategoriesForUnit(unit),
                "prevent-unit-selection": false,
                "is-selectable": false,
                "collapsed-view": _vm.collapsedView,
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }